<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" menuId="main_menu" disabled="" swipe-gesture="false" class="app-menu">
      <ion-content class="app-menu-content">
          <div class="menu-title"><img src="/assets/logo/G2U_Symbol_Red_RGB.png" class="menu-logo" /></div>
          <ion-list id="inbox-list" class="app-menu-list">
         <ion-menu-toggle auto-hide="false" data-testid="side-menu">
              <ion-item routerDirection="root" routerLink="/home" lines="none" detail="false"  routerLinkActive="selected" data-testid="side-menu-home">
                  <ion-icon slot="start" ios="home-outline" md="home-outline"></ion-icon>
                  <ion-label>Home</ion-label>
              </ion-item>
              <ion-item routerDirection="root" routerLink="/jobs" lines="none" detail="false"  routerLinkActive="selected" data-testid="side-menu-jobs">
                  <ion-icon slot="start" ios="car-outline" md="car-outline"></ion-icon>
                  <ion-label>Jobs</ion-label>
              </ion-item>
              <ion-item routerDirection="root" routerLink="/availability" lines="none" detail="false"  routerLinkActive="selected" data-testid="side-menu-availability">
                  <ion-icon slot="start" ios="calendar-outline" md="calendar-outline"></ion-icon>
                  <ion-label>Availability</ion-label>
              </ion-item>
              <ion-item routerDirection="root" routerLink="/skill-sets" lines="none" detail="false"  routerLinkActive="selected" data-testid="side-menu-skill-sets">
                  <ion-icon slot="start" ios="build-outline" md="build-outline"></ion-icon>
                  <ion-label>Skill Sets</ion-label>
              </ion-item>
              <ion-item routerDirection="root" routerLink="/service-area" lines="none" detail="false"  routerLinkActive="selected" data-testid="side-menu-service-area">
                  <ion-icon slot="start" ios="map-outline" md="map-outline"></ion-icon>
                  <ion-label>Service Area</ion-label>
              </ion-item>
              <ion-item routerDirection="root" routerLink="/quotes" lines="none" detail="false"  routerLinkActive="selected" data-testid="side-menu-quotes">
                  <ion-icon slot="start" ios="pricetags-outline" md="pricetags-outline"></ion-icon>
                  <ion-label>Quotes</ion-label>
              </ion-item>
              <ion-item routerDirection="root" routerLink="/tickets" lines="none" detail="false"  routerLinkActive="selected" data-testid="side-menu-tickets">
                  <ion-icon slot="start" ios="list-circle-outline" md="list-circle-outline"></ion-icon>
                  <ion-label>Tickets</ion-label>
              </ion-item>
             <ion-item routerDirection="root" routerLink="/inventory" lines="none" detail="false"  routerLinkActive="selected"data-testid="side-menu-inventory">
                 <ion-icon slot="start" ios="desktop-outline" md="desktop-outline"></ion-icon>
                 <ion-label>Inventory</ion-label>
             </ion-item>
             <ion-item routerDirection="root" routerLink="/invoices" lines="none" detail="false"  routerLinkActive="selected" data-testid="side-menu-invoices">
                 <ion-icon slot="start" ios="receipt-outline" md="receipt-outline"></ion-icon>
                 <ion-label>Invoices</ion-label>
             </ion-item>
            <ion-item routerDirection="root" routerLink="/knowledge" lines="none" detail="false"  routerLinkActive="selected" data-testid="side-menu-help-centre">
              <ion-icon slot="start" ios="book-outline" md="book-outline"></ion-icon>
              <ion-label>Help Centre</ion-label>
            </ion-item>
            <ion-item routerDirection="root" [routerLink]="knowledgeLink" lines="none" detail="false"  routerLinkActive="selected" data-testid="side-menu-contact-us">
              <ion-icon slot="start" ios="chatbubble-ellipses-outline" md="chatbubble-ellipses-outline"></ion-icon>
              <ion-label>Contact Us</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>

  </ion-split-pane>

</ion-app>
